import React from 'react';
import Button from 'shared/components/andtComponents/Button';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';
import { useRootStore } from 'app/contexts/RootStoreContext';
import { OrganizationLearnMoreLinks } from 'app/contexts/Brand/configurations/external-links.configuration';

import styles from './LearnMoreOrganizationLevel.module.scss';

const LearnMoreOrganizationLevel = () => {
  const { usersStore } = useRootStore();
  const { isCurrentUserReseller } = usersStore;

  const handleInfoLinkClicked = (learnMoreLink) => {
    window.open(learnMoreLink, '_blank');
  };

  const learnMoreEntities = {
    ROLES: { label: 'Roles', link: OrganizationLearnMoreLinks.Roles, isDisplayed: true },
    USERS: { label: 'Users', link: OrganizationLearnMoreLinks.Users, isDisplayed: true },
    COST_CENTERS: { label: 'Cost Centers', link: OrganizationLearnMoreLinks.CostCenters, isDisplayed: true },
    CUSTOMERS: {
      label: 'Customers',
      link: OrganizationLearnMoreLinks.Customers,
      isDisplayed: isCurrentUserReseller && false, // TODO:  change condition when Customers link is ready
    },
  };

  return (
    <div className={styles.container}>
      <GenerateIcon iconName={ICONS.lightbulb.name} className={styles.lightBulbIcon} />
      <div className={styles.learnMoreContainer}>
        <div className={styles.learnMoreTitle}>Learn more about the new User Management features:</div>
        <div className={styles.learnMoreButtonsContainer}>
          {Object.keys(learnMoreEntities).map((key) => {
            const entity = learnMoreEntities[key];
            if (entity.isDisplayed) {
              return (
                <Button
                  key={key}
                  className={{ button: styles.learnMoreButton }}
                  isTextButton
                  onClick={() => handleInfoLinkClicked(entity.link)}
                  text={entity.label}
                />
              );
            }
            return null;
          })}
        </div>
      </div>
    </div>
  );
};

export default LearnMoreOrganizationLevel;
